<div class="checkout-wrapper">

  <!-- ── Already paid screen ─────────────────────────────────────────── -->
  <div class="checkout-box already-paid-box" *ngIf="paymentAlreadyComplete">
    <div class="already-paid-icon">✅</div>
    <h2>Payment Already Completed</h2>
    <p>This payment has already been processed successfully.</p>
    <p class="already-paid-sub">If you need help, please contact support.</p>
  </div>

  <!-- ── Normal checkout form ──────────────────────────────────────────── -->
  <div *ngIf="!paymentAlreadyComplete">
  <div class="checkout-box">
    <!-- Header -->
    <div class="checkout-header">
      <img src="assets/images/logo.svg" alt="Logo" class="logo" />
      <h1>${{userInfo?.amount}}</h1>
    </div>

    <!-- Form -->
    <form [formGroup]="checkoutForm" (ngSubmit)="onSubmit()">
      <!-- Email -->
      <div class="form-group">
        <label>Email</label>
        <input
        readonly
          type="email"
          formControlName="email"
          placeholder="email@example.com"
        />
      </div>

      <h4 class="section-title">Payment method</h4>

      <!-- Card number -->
      <div class="form-group">
        <label>Card information</label>
        <div class="card-input">
          <input
            type="text"
            formControlName="cardNumber"
            placeholder="4111 1111 1111 1111"
            maxlength="19"
            (input)="formatCardNumber($event)"
          />
          <div class="icons">
            <img src="assets/images/visa.png" alt="Visa" />
            <img src="assets/images/mastercard.png" alt="Mastercard" />
            <img src="assets/images/amex.png" alt="Amex" />
          </div>
        </div>

        <small class="error" *ngIf="
          checkoutForm.get('cardNumber')?.touched &&
          checkoutForm.get('cardNumber')?.errors?.['invalidCard']
        ">
          Please enter a valid Card Number.
        </small>

        <div class="inline-inputs">

          <!-- Expiry Date Input -->
          <div class="input-wrapper">
            <input
              type="text"
              formControlName="expiryDate"
              placeholder="MM/YY"
              maxlength="5"
              (input)="formatExpiry($event)"
            />
        
            <small class="error" *ngIf="
              checkoutForm.get('expiryDate')?.touched &&
              checkoutForm.get('expiryDate')?.errors?.['expired']
            ">
              Your card has expired. Please use another card with a future expiry date.
            </small>
          </div>
        
          <!-- CVV Input -->
          <div class="input-wrapper">
            <input
              type="password"
              formControlName="cvv"
              maxlength="3"
              placeholder="CVV"
            />
        
            <small class="error" *ngIf="
              checkoutForm.get('cvv')?.touched &&
              checkoutForm.get('cvv')?.errors?.['pattern']
            ">
              Please enter a valid CVV.
            </small>
          </div>
        
        </div>
      </div>

      <!-- Name -->
      <div class="form-group">
        <label>Cardholder name</label>
        <input
          type="text"
          formControlName="cardName"
          placeholder="Full name on card"
        />

        <small class="error" *ngIf="
          checkoutForm.get('cardName')?.touched &&
          checkoutForm.get('cardName')?.errors?.['pattern']
        ">
          Please enter valid full name
        </small>
      </div>

      <!-- ZIP -->
      <div class="form-group">
        <label>ZIP Code</label>
        <input
          type="text"
          formControlName="postal_code"
          placeholder="12345"
          maxlength="6"
        />
        <small class="error" *ngIf="
          checkoutForm.get('postal_code')?.touched &&
          checkoutForm.get('postal_code')?.errors?.['pattern']
        ">
          Please enter valid zipcode.
        </small>
      </div>

      <!-- Pay button -->
      <button
        type="submit"
        class="pay-btn"
        [disabled]="checkoutForm.invalid || isLoading"
        (click)="onSubmit()"
      >
        <span *ngIf="!isLoading">Pay ${{userInfo?.amount}}</span>
        <span *ngIf="isLoading" class="loader"></span>
      </button>
    </form>
  </div>
  </div>
</div>
